module.exports = __webpack_public_path__ + "static/media/outlook_express.eaee18df.ico";